export default "__VITE_ASSET__DUdhyNco__"